import HeaderDashboard from "../../Components/HeaderDashboard";
import React, { useEffect, useState, useRef } from "react";
import { Navigate, useNavigate, useLocation } from "react-router-dom";
import { FlightBookingDetails,FlightTransactionDetails, CancelBooking } from "../../Services/API";

const CancellationBooking = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const referenceNo = queryParams.get("ReferenceNo");
  const trackId = queryParams.get("trackID");

  const [flightDetails, setFlightDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [cancelReason, setCancelReason] = useState("");
  const [comments, setComments] = useState("");
  const [showCancellationPopup, setShowCancellationPopup] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showFailPopup, setShowFailPopup] = useState(false);

  const hasFetched = useRef(false);
  useEffect(() => {
    if (hasFetched.current) return;
    if (referenceNo && trackId) {
      hasFetched.current = true;
      fetchFlightBookingDetails(referenceNo, trackId);
    } else {
      console.warn("Missing referenceNo and trackId");
    }
  }, [referenceNo, trackId]);

  const fetchFlightBookingDetails = async (referenceNo, trackId) => {
    try {
      setLoading(true);
      setError("");
      const params = { ReferenceNo: referenceNo, TrackID: trackId, ClientCode: "BerryJourneys", Key: "", SessionID: "" };
      const response = await FlightTransactionDetails(params);
      setFlightDetails(response);
      //console.log("response::", flightDetails?.airBookingResponse?.[0]?.customerInfo?.passengerDetails)
    } catch (err) {
      setError("Failed to load flight Booking details. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  /* -------------------- STATES -------------------- */
  const [selectedTickets, setSelectedTickets] = useState([]);

  const handlePassengerSelect = (ticketIndex) => {
    setSelectedTickets(prev => {
      if (prev.includes(ticketIndex)) {
        return prev.filter(id => id !== ticketIndex);
      } else {
        return [...prev, ticketIndex];
      }
    });
  };

  const CancelledMyBooking = async () => {
    if (!selectedTickets.length) {
      alert("Please select at least one passenger");
      return;
    }
    //alert(selectedTickets);

    if (!cancelReason) {
      alert("Please select cancellation reason");
      return;
    }

    setShowCancellationPopup(true);
  }
  const ContinueCancellation = async () => {
    try {
      setLoading(true);

      const requestBody = {
        status: null,
        key: flightDetails?.airBookingResponse[0]?.sessionID,
        clientCode: "BerryJourneys",
        referenceNo: referenceNo,
        trackIDs: flightDetails?.airBookingResponse[0]?.flightDetails[0]?.trackID,
        cancellationReason: cancelReason,
        ticketIndexs: selectedTickets.toString(),
        cancellationRemarks: comments,
        error: null,
      };

      const response = await CancelBooking(requestBody);
      console.log("Cancellation success:", response);
      if (response?.status === "success") {
        setShowCancellationPopup(false);
        setShowSuccessPopup(true);
      }
      else {
        setShowCancellationPopup(false);
        setShowFailPopup(true);
      }

      // if (response.status === "success") {
      //   alert("Ticket cancelled successfully");

      //   navigate(
      //     `/Reservations/Flight/TransactionDetails?referenceNo=${referenceNo}`
      //   );

      // } else {
      //   alert("Oops, action not completed.!!");
      // }

    } catch (error) {
      console.error(error);
      alert("Cancellation failed");
    } finally {
      setLoading(false);
    }
  };

  const GOTODEtailsPage = () => {
    setShowSuccessPopup(false);
    setTimeout(() => {
      navigate(
        `/Reservations/Flight/TransactionDetails?referenceNo=${referenceNo}`
      );
    });
  }

  return (
    <>
      {loading && (
        <p class="text-center load"><span class="loader"></span></p>
      )}
      <HeaderDashboard />
      <div className="toolbar py-2" id="kt_toolbar">
        <div id="kt_toolbar_container" className="container-fluid d-flex align-items-center">
          <div className="flex-grow-1 flex-shrink-0 me-5">
            <div data-kt-swapper="true" data-kt-swapper-mode="prepend" data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}" className="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0">
              <h1 className="d-flex align-items-center text-gray-900 fw-bold my-1 fs-3">Reservations</h1>
              <span className="h-20px border-gray-200 border-start mx-3"></span>
              <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-1">
                <li class="breadcrumb-item text-muted">Flight</li>
                <li class="breadcrumb-item">
                  <span class="bullet bg-gray-200 w-5px h-2px"></span>
                </li>

                <li class="breadcrumb-item text-gray-900">Cancellation Booking</li>
              </ul>
            </div>
          </div>
          <div class="d-flex align-items-center flex-wrap">
            <div class="flex-shrink-0">
              <ul class="nav" role="tablist">
                <li class="nav-item" role="presentation">
                  <a href="#" onClick={(e) => { e.preventDefault(); window.history.back(); }} >
                    <img src="/assets/images/back.png" className="imgBack" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <section className="wraper">
        <div className="box_shadow mt-14">
          <div className="row">
            {/* Ticket details */}
            {flightDetails && flightDetails.airBookingResponse.length > 0 ? (
              <>
                <div class="row mamage_depo">
                  <div class="col-lg-6">
                    <h6 className='ruler'>Flight Booking Details</h6>
                  </div>

                </div>
                <div className='col-md-12 col-lg-12'>
                  <div className='table-responsive'>
                    <table className='table table-bordered'>
                      <thead>
                        <tr>
                          <th>Reference No</th>
                          <th>Confirmation Number (PNR)</th>
                          <th>Booking Status</th>
                          <th>Ticketing Status</th>
                          <th>Booking Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{flightDetails.referenceNo}</td>
                          <td>{flightDetails.airBookingResponse[0].pnr}</td>
                          <td>{flightDetails.airBookingResponse[0].bookingStatus}</td>
                          <td>{flightDetails.airBookingResponse[0].ticketingStatus}</td>
                          <td>{flightDetails.airBookingResponse[0].bookingDate}</td>

                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className='col-md-12 col-lg-12'>
                  <h6 className='ruler'>Travel Information</h6>
                  <div className='table-responsive'>
                    <table class="table table-bordered">
                      <tbody>
                        <tr>
                          <th>Travel Date</th>
                          <th>Flight No.</th>
                          <th>Aircraft Type</th>
                          <th>From / Terminal </th>
                          <th>To / Terminal</th>
                          <th>Dep Time</th>
                          <th>Arr Time</th>
                          <th>Airline</th>
                        </tr>
                        {flightDetails?.airBookingResponse?.map((bookingResponse, bookingIndex) => (
                          bookingResponse?.flightDetails?.map((flight, flightIndex) => (
                            <tr key={`${bookingIndex}-${flightIndex}`}>
                              <td>
                                {new Date(flight.departDateTime).toLocaleDateString("en-US", {
                                  weekday: "short",
                                  day: "2-digit",
                                  month: "short",
                                  year: "numeric"
                                }).replace(",", " ,")}
                              </td>
                              {/* <td>{flight.DepartDateTime}</td> */}
                              <td>{flight.airLineCode} - {flight.flightNumber}</td>
                              <td><samp>N/A</samp></td>
                              <td class="dropdown-caps">{flight.departAirportCode} <span>:{flight.departTerminal}</span></td>
                              <td class="dropdown-caps">{flight.arrivalAirportCode}  <span>:{flight.arrivalTerminal}</span></td>
                              <td>
                                {new Date(flight.departDateTime).toLocaleString("en-GB", {
                                  weekday: "short",
                                  day: "2-digit",
                                  month: "short",
                                  year: "numeric",
                                  hour: "2-digit",
                                  minute: "2-digit",
                                })}
                              </td>

                              <td>
                                {new Date(flight.arrivalDateTime).toLocaleString("en-GB", {
                                  weekday: "short",
                                  day: "2-digit",
                                  month: "short",
                                  year: "numeric",
                                  hour: "2-digit",
                                  minute: "2-digit",
                                })}
                              </td>
                              <td>{flight.airLineName}</td>
                            </tr>
                          ))
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>




              </>
            ) : (
              !loading && flightDetails && (
                <>
                  <div class="row mamage_depo">
                    <div class="col-lg-12">
                      <h6 className='ruler'>Flight Booking Details</h6>
                    </div>
                    <div class="col-lg-12">
                      <p className=''>No Flight Booking Details Found !!</p>
                    </div>
                  </div>
                </>
              )
            )}




            {/* Ticket details */}
            <div className="col-lg-12">
              <h6 className="ruler">Passenger Ticket Details</h6>
              <div class="alert alert-info mb-3">
    <div class="fw-semibold mb-1">
        <i class="fa fa-info-circle me-1"></i> Cancellation Process
    </div>
    <div class="mb-1">
        <strong>Full Cancellation:</strong> You can cancel the entire PNR directly from this page by selecting all passengers and proceeding with the cancellation.
    </div>
    <div>
        <strong>Partial Cancellation:</strong> If you wish to cancel tickets for specific passengers only, please contact your booking consultant.
    </div>
</div>
            </div>
            <div className="col-md-12">
              <div className="table-responsive">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Cancel Ticket<span className="required"></span></th>
                      <th>Name</th>
                      <th>Pax Type</th>
                      <th>DOB</th>
                      <th>Ticket ID</th>
                      <th>Ticket No</th>
                      <th>Status</th>
                    </tr>
                  </thead>

                  <tbody>
                    {flightDetails?.airBookingResponse?.[0]?.customerInfo?.passengerTicketDetails?.map((pax, index) => (
                      <tr key={index}>
                        <td>
                          <input
                            type="checkbox"
                            className="checkBox"
                            checked={selectedTickets.includes(pax.ticketIndex)}
                            onChange={() => handlePassengerSelect(pax.ticketIndex)}
                          />
                        </td>
                        <td>{pax.title}. {pax.firstName} {pax.lastName}</td>
                        <td>{pax.paxTypeCode}</td>
                        <td>{pax.dob}</td>
                        <td>{pax.ticketID}</td>
                        <td>{pax.ticketNumber}</td>
                        <td>{pax.status}</td>

                      </tr>
                    ))}

                  </tbody>

                </table>
              </div>
            </div>
            {/* Passenger Table */}


            {/* Cancellation Reason */}
            <div className="col-md-12 mb-3 remrk">
              <h6 className="ruler">Cancellation Reason<span className="required"></span></h6>

              {[
                "Change in travel plans",
                "Medical emergency",
                "Personal emergency",
                "Incorrect booking",
                "Duplicate booking",
                "Visa issues",
                "Bad weather",
                "Work commitments",
                "Other",
              ].map((reason, idx) => (
                <div className="form-check mt-2" key={idx}>
                  <input
                    type="radio"
                    className="form-check-input"
                    name="cancelReason"
                    value={reason}
                    checked={cancelReason === reason}
                    onChange={(e) => setCancelReason(e.target.value)}
                  />
                  <label className="form-check-label">{reason}</label>
                </div>
              ))}
            </div>

            {/* Reference No */}
            <div className="col-md-3" style={{ display: 'none' }}>
              <label>Reference No</label>
              <input
                type="text"
                className="form-control"
                value={referenceNo}
              //onChange={(e) => setReferenceNo(e.target.value)}
              />
            </div>

            {/* Comments */}
            <div className="col-md-12 mt-3">
              <label>Write Comments</label>
              <textarea
                className="form-controls"
                rows="3"
                value={comments}
                onChange={(e) => setComments(e.target.value)} placeholder="Write comments..."
              />
            </div>

            {/* Submit */}
            <div className="col-md-12 mt-4 text-end">
              <button
                type="button"
                className="btn btn-primary"
                onClick={CancelledMyBooking}
                disabled={loading}
              >
                {loading ? "..." : "Cancel Ticket"}
              </button>
            </div>
          </div>
        </div>
      </section>

      {showCancellationPopup && (
        <div
          className="modal fade show"
          style={{
            display: "block",
            backgroundColor: "rgba(0,0,0,0.5)"
          }}
        >
          {loading && (
            <p class="text-center load"><span class="loader"></span></p>
          )}
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">

              <div className="modal-header">
                <h5 className="modal-title">
                  Cancellation Details
                </h5>

                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowCancellationPopup(false)}
                ></button>
              </div>

              <div className="modal-body">
                <div className="text-danger fw-bold mt-3">
                  Are you sure you want to cancel this ticket?
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowCancellationPopup(false)}
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={ContinueCancellation}
                  disabled={loading}
                >
                  {loading ? "..." : "Cancel Ticket"}
                </button>

              </div>

            </div>
          </div>
        </div>
      )}

      {showSuccessPopup && (
        <div
          className="modal fade show"
          style={{
            display: "block",
            backgroundColor: "rgba(0,0,0,0.5)"
          }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">

              <div className="modal-header">
                <h5 className="modal-title text-success">
                  Cancellation Successful
                </h5>

                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowSuccessPopup(false)}
                ></button>
              </div>

              <div className="modal-body text-center">
                <div className="text-success mb-3">
                  <i className="fa fa-check-circle fa-3x"></i>
                </div>

                <h5 className="text-success">
                  {success}
                </h5>

                <p className="text-muted mb-0">
                  Your ticket has been cancelled successfully.
                </p>
              </div>

              <div className="modal-footer justify-content-center">
                <button
                  type="button"
                  className="btn btn-success"
                  // onClick={() => setShowSuccessPopup(false)}
                  onClick={GOTODEtailsPage}
                >
                  OK
                </button>
              </div>

            </div>
          </div>
        </div>
      )}

      {showFailPopup && (
        <div
          className="modal fade show"
          style={{
            display: "block",
            backgroundColor: "rgba(0,0,0,0.5)"
          }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">

              <div className="modal-header">
                <h5 className="modal-title text-danger">
                  Cancellation failure
                </h5>

                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowFailPopup(false)}
                ></button>
              </div>

              <div className="modal-body text-center">
                <div className="text-danger mb-3">
                  <i className="fa fa-times-circle fa-3x text-danger"></i>
                </div>

                <h5 className="text-danger">
                  {success}
                </h5>

                <p className="text-muted mb-0">
                  An error occurred while processing the cancellation request.
                </p>
              </div>

              <div className="modal-footer justify-content-center">
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={() => setShowFailPopup(false)}
                >
                  OK
                </button>
              </div>

            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CancellationBooking;
